import React from "react";

const About: React.FC = () => (
  <div className="About page-container max-960 legacy-bs-override">
    <div className="card">
      <h2 className="lt" style={{ marginTop: 0, fontSize: 25 }}>
        OUR <b>MISSION</b>
      </h2>
      <p className="md">
        To streamline affordable housing applications so you can eliminate data entry and
        unnecessary phone calls, thereby transforming the way your low-income applicants keep track
        of their housing applications. Our obsession with efficiency stems from the belief that when
        you cut out the busy work, you can focus on the heart of your business: your tenants.
      </p>

      <h2 className="lt" style={{ fontSize: 25 }}>
        OUR <b>VISION</b>
      </h2>
      <p className="md">
        To transform the way that property managers and their applicants communicate through an easy
        to use, secure, regulatory-compliant, and cost-effective application submission system.
      </p>

      <h2 className="lt" style={{ fontSize: 25 }}><b>HOW</b> WE DO IT</h2>
      <p className="md">
        We convert your existing PDF housing application into a beautiful, easy-to-navigate online
        application.
      </p>

      <p className="md">
        Add a unique “Apply” button to your existing marketing website, and let the applications
        come rolling in!
      </p>

      <p className="md">
        We digitize your paper applications and integrate them with online submissions, then return
        them to you in one organized hub. Future tenants receive instant email or text message
        confirmation when they apply online.
      </p>

      <h2 className="lt" style={{ fontSize: 25 }}>
        OUR <b>COMPANY</b>
      </h2>
      <p className="md">
        Started in San Francisco in 2014 by a team with a long history in social services, we are
        familiar with your desire to streamline the application process as well as the needs of
        low-income applicants.
      </p>
    </div>
  </div>
);

export default About;
